import type { Provider } from "@supabase/supabase-js";
import discordIcon from "~/assets/icons/discord.svg";
import googleIcon from "~/assets/icons/google.svg";
import slackIcon from "~/assets/icons/slack.svg";

export type LoginProvider = Extract<Provider, "google" | "slack_oidc" | "discord">;

export type LoginProviderConfig = {
  id: LoginProvider;
  labelKey: string;
  icon: string;
  queryParams?: Record<string, string>;
  scopes?: string;
};

export const LOGIN_PROVIDERS: LoginProviderConfig[] = [
  {
    id: "google",
    labelKey: "auth.login.googleButton",
    icon: googleIcon,
    queryParams: { access_type: "offline", prompt: "consent" },
  },
  {
    id: "slack_oidc",
    labelKey: "auth.login.slackButton",
    icon: slackIcon,
    scopes: "openid profile email",
  },
  {
    id: "discord",
    labelKey: "auth.login.discordButton",
    icon: discordIcon,
  },
];
